import React from 'react';

const Skeleton = ({ className = 'h-4 w-32' }) => (
    <div className={`bg-neutral-100 rounded animate-pulse-soft ${className}`} />
);

export default Skeleton;
